
import './App.css';
import Home from './Screen/Home';

function App() {
  return (
    <div className="App">
      <Home/>
    </div>
  );
}

export default App;
